export default __webpack_public_path__ + "static/media/11.e885f9e6.jpg";